import React from 'react'

import { Text } from '@mantine/core'
import {
  ColumnDef,
  createColumnHelper,
  DisplayColumnDef,
} from '@tanstack/react-table'
import dayjs from 'dayjs'

import { EXPORT_VALUE_CELL_FIELD } from '../../../constants'

type UpdatedAtColumnValue = {
  updated_at: string | null
  [EXPORT_VALUE_CELL_FIELD]: string
}

const updatedAtColumn = <
  T extends Record<'updated_at', string | null>,
>(params?: {
  accessor?: (row: T) => UpdatedAtColumnValue
  column?: Partial<DisplayColumnDef<T, UpdatedAtColumnValue>>
}): ColumnDef<T, UpdatedAtColumnValue> => {
  const columnHelper = createColumnHelper<T>()

  const defaultAccessor: (row: T) => UpdatedAtColumnValue = (row) => {
    return {
      updated_at: row.updated_at,
      [EXPORT_VALUE_CELL_FIELD]: row.updated_at
        ? dayjs(row.updated_at).format('DD.MM.YYYY HH:mm')
        : i18n.t('columnsnot_updated_at', 'Noch nicht aktualisiert'),
    }
  }

  const accessorFn = params?.accessor ?? defaultAccessor

  const updatedAtColumn = columnHelper.accessor(accessorFn, {
    header: i18n.t('columnsupdated_at', 'Aktualisiert am'), //i18n.t('columns.updated_at', { ns: 'common' }).toString(),
    id: 'updated_at',
    cell: (cell) =>
      cell.getValue().updated_at ? (
        <Text align="right">
          {dayjs(cell.getValue().updated_at).format('DD.MM.YYYY HH:mm')}
        </Text>
      ) : (
        <Text
          italic
          align="right"
          color="dimmed"
        >
          {/* {i18n.t('columns.not_updated_at', { ns: 'common' }).toString()} */}
          {i18n.t('columnsnot_updated_at', 'Noch nicht aktualisiert')}
        </Text>
      ),
    minSize: 160,
    ...params?.column,
  })

  return updatedAtColumn
}

export default updatedAtColumn
